export const categories = [
  { slug: 'romance', name: '恋爱漫画', icon: 'ri-heart-line', description: '浪漫甜蜜的恋爱故事，感受韩式浪漫' },
  { slug: 'action', name: '动作热血', icon: 'ri-fire-line', description: '热血沸腾的动作冒险漫画' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '充满想象力的奇幻世界冒险' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', description: '现代都市背景下的精彩剧情' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '扣人心弦的悬疑推理故事' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑治愈漫画' },
  { slug: 'bl', name: 'BL漫画', icon: 'ri-star-line', description: '人气BL漫画作品合集' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line', description: '一次性看个够的完结漫画' },
];

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  description: string;
  tags: string[];
  updatedAt: string;
  featured?: boolean;
  hot?: boolean;
  chapterList?: { num: number; title: string; date: string }[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '秘密花园',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20couple%20under%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20clean%20minimal%20background%20with%20gentle%20gradient%2C%20professional%20digital%20illustration%20style%2C%20elegant%20composition&width=400&height=560&seq=comic-01&orientation=portrait',
    category: 'romance',
    rating: 9.5,
    views: 2850000,
    chapters: 86,
    status: '连载中',
    description: '平凡的女大学生意外进入了一所神秘的贵族学院，在这里她遇见了改变她一生的那个人。隐藏在华丽外表下的秘密，随着故事深入逐渐浮出水面。一段关于成长、爱情与自我发现的浪漫故事。',
    tags: ['校园', '恋爱', '治愈', '成长'],
    updatedAt: '2026-08-04',
    featured: true,
    hot: true,
    chapterList: [
      { num: 86, title: '第86话 - 新的开始', date: '2026-08-04' },
      { num: 85, title: '第85话 - 告白之夜', date: '2026-07-28' },
      { num: 84, title: '第84话 - 心动的信号', date: '2026-07-21' },
      { num: 83, title: '第83话 - 不速之客', date: '2026-07-14' },
      { num: 82, title: '第82话 - 雨中的约定', date: '2026-07-07' },
    ],
  },
  {
    id: 2,
    title: '暗黑骑士',
    author: '李泰民',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20dark%20knight%20warrior%20with%20sword%20in%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20warm%20gold%20accents%2C%20clean%20dark%20background%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-02&orientation=portrait',
    category: 'action',
    rating: 9.3,
    views: 1980000,
    chapters: 112,
    status: '连载中',
    description: '在被黑暗势力笼罩的世界里，一位被选中的年轻骑士踏上了拯救王国的征程。强大的敌人、忠诚的伙伴、隐藏的身世之谜，这一切将引领他走向何方？',
    tags: ['战斗', '冒险', '热血', '奇幻'],
    updatedAt: '2026-08-03',
    featured: true,
    hot: true,
    chapterList: [
      { num: 112, title: '第112话 - 最终决战前夕', date: '2026-08-03' },
      { num: 111, title: '第111话 - 觉醒之力', date: '2026-07-27' },
      { num: 110, title: '第110话 - 王国的秘密', date: '2026-07-20' },
      { num: 109, title: '第109话 - 盟友归来', date: '2026-07-13' },
    ],
  },
  {
    id: 3,
    title: '魔法学院',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20magical%20academy%20students%20casting%20spells%2C%20vibrant%20colors%20with%20mystical%20glow%20effects%2C%20clean%20ethereal%20background%2C%20professional%20digital%20illustration%20style&width=400&height=560&seq=comic-03&orientation=portrait',
    category: 'fantasy',
    rating: 9.6,
    views: 3200000,
    chapters: 95,
    status: '连载中',
    description: '一个平凡少年意外发现自己拥有强大的魔法天赋，被邀请进入传说中的魔法学院。在这里，他结识了志同道合的朋友，也面临着前所未有的挑战。魔法世界的精彩冒险就此展开。',
    tags: ['魔法', '学院', '冒险', '成长'],
    updatedAt: '2026-08-05',
    featured: true,
    hot: true,
    chapterList: [
      { num: 95, title: '第95话 - 魔法大赛', date: '2026-08-05' },
      { num: 94, title: '第94话 - 禁术对决', date: '2026-07-29' },
      { num: 93, title: '第93话 - 隐藏的力量', date: '2026-07-22' },
      { num: 92, title: '第92话 - 新学期的挑战', date: '2026-07-15' },
    ],
  },
  {
    id: 4,
    title: '都市夜话',
    author: '郑多彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20modern%20city%20night%20scene%20with%20two%20office%20workers%2C%20warm%20neon%20lighting%2C%20sophisticated%20urban%20aesthetic%2C%20clean%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-04&orientation=portrait',
    category: 'drama',
    rating: 9.1,
    views: 1560000,
    chapters: 68,
    status: '连载中',
    description: '在大都市的霓虹灯下，四位年轻人的命运交织在一起。职场、爱情、友情、梦想，每个人都有不为人知的故事。当夜幕降临，真实的自己才开始显现。',
    tags: ['职场', '恋爱', '都市', '现实'],
    updatedAt: '2026-08-02',
    chapterList: [
      { num: 68, title: '第68话 - 升职风波', date: '2026-08-02' },
      { num: 67, title: '第67话 - 秘密约会', date: '2026-07-26' },
      { num: 66, title: '第66话 - 意外重逢', date: '2026-07-19' },
    ],
  },
  {
    id: 5,
    title: '第七层',
    author: '崔俊昊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20mysterious%20figure%20in%20dark%20corridor%20with%20eerie%20atmosphere%2C%20moody%20lighting%20with%20cool%20tones%2C%20minimalist%20suspenseful%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-05&orientation=portrait',
    category: 'thriller',
    rating: 9.4,
    views: 2120000,
    chapters: 54,
    status: '连载中',
    description: '一栋大楼的第七层发生了离奇失踪案。侦探金志勋接手案件后，发现事情远比他想象的复杂。每一扇门背后都藏着秘密，每一个住户都有嫌疑。真相到底是什么？',
    tags: ['悬疑', '推理', '惊悚', '侦探'],
    updatedAt: '2026-08-01',
    chapterList: [
      { num: 54, title: '第54话 - 最后一位嫌疑人', date: '2026-08-01' },
      { num: 53, title: '第53话 - 监控死角', date: '2026-07-25' },
      { num: 52, title: '第52话 - 破碎的不在场证明', date: '2026-07-18' },
    ],
  },
  {
    id: 6,
    title: '隔壁的猫',
    author: '尹瑞妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20cute%20cat%20and%20funny%20characters%20in%20apartment%20setting%2C%20bright%20cheerful%20colors%2C%20playful%20minimalist%20composition%2C%20professional%20digital%20illustration%20style&width=400&height=560&seq=comic-06&orientation=portrait',
    category: 'comedy',
    rating: 9.0,
    views: 1350000,
    chapters: 72,
    status: '连载中',
    description: '一个怕猫的漫画家搬进了一栋"猫咪公寓"。每天和各种各样的猫咪以及它们的主人斗智斗勇。爆笑日常就此展开，温馨治愈又让人捧腹大笑。',
    tags: ['日常', '搞笑', '猫咪', '治愈'],
    updatedAt: '2026-08-04',
    chapterList: [
      { num: 72, title: '第72话 - 猫咪选美大赛', date: '2026-08-04' },
      { num: 71, title: '第71话 - 新来的布偶猫', date: '2026-07-28' },
      { num: 70, title: '第70话 - 猫粮大战', date: '2026-07-21' },
    ],
  },
  {
    id: 7,
    title: '星月传说',
    author: '韩智敏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20cover%20art%2C%20two%20handsome%20male%20characters%20under%20starry%20night%20sky%2C%20soft%20romantic%20atmosphere%2C%20elegant%20pastel%20colors%2C%20clean%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-07&orientation=portrait',
    category: 'bl',
    rating: 9.7,
    views: 4100000,
    chapters: 78,
    status: '连载中',
    description: '在古代朝鲜的星空下，王世子与平民少年之间跨越阶层的深情故事。细腻的情感描绘，动人的剧情发展，被读者誉为年度最佳BL漫画。',
    tags: ['古风', 'BL', '浪漫', '深情'],
    updatedAt: '2026-08-05',
    hot: true,
    chapterList: [
      { num: 78, title: '第78话 - 月下的誓言', date: '2026-08-05' },
      { num: 77, title: '第77话 - 王宫之乱', date: '2026-07-29' },
      { num: 76, title: '第76话 - 真心相待', date: '2026-07-22' },
    ],
  },
  {
    id: 8,
    title: '剑之王',
    author: '张贤宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20warrior%20holding%20sword%20in%20ancient%20battlefield%2C%20dramatic%20sunset%20lighting%2C%20epic%20atmosphere%2C%20clean%20powerful%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-08&orientation=portrait',
    category: 'action',
    rating: 9.2,
    views: 1780000,
    chapters: 120,
    status: '已完结',
    description: '乱世之中，一个被遗弃的孤儿凭借不屈的意志成为天下第一剑客。从无名小卒到一剑封神的传奇故事。热血沸腾的战斗场面，感人至深的师徒情谊。',
    tags: ['武侠', '战斗', '热血', '成长'],
    updatedAt: '2026-07-15',
    status: '已完结',
    chapterList: [
      { num: 120, title: '第120话 - 剑神降临（完结）', date: '2026-07-15' },
      { num: 119, title: '第119话 - 最后的试炼', date: '2026-07-08' },
      { num: 118, title: '第118话 - 巅峰之战', date: '2026-07-01' },
    ],
  },
  {
    id: 9,
    title: '恋爱法则',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20young%20couple%20in%20coffee%20shop%2C%20warm%20cozy%20atmosphere%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-09&orientation=portrait',
    category: 'romance',
    rating: 9.3,
    views: 1960000,
    chapters: 64,
    status: '连载中',
    description: '恋爱小白程序员遇上了情感咨询师，两人因为一款恋爱APP的开发而走到一起。程序员的浪漫，原来可以这样表达。甜蜜中带着笑料，温暖又治愈。',
    tags: ['恋爱', '职场', '甜宠', '治愈'],
    updatedAt: '2026-08-03',
    chapterList: [
      { num: 64, title: '第64话 - APP上线日', date: '2026-08-03' },
      { num: 63, title: '第63话 - 程序员的告白', date: '2026-07-27' },
      { num: 62, title: '第62话 - 加班夜的惊喜', date: '2026-07-20' },
    ],
  },
  {
    id: 10,
    title: '异世界药神',
    author: '姜成勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20alchemist%20in%20magical%20laboratory%20with%20glowing%20potions%2C%20mystical%20warm%20lighting%2C%20clean%20enchanting%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-10&orientation=portrait',
    category: 'fantasy',
    rating: 9.5,
    views: 2450000,
    chapters: 88,
    status: '连载中',
    description: '天才药剂师在实验中意外穿越到异世界。在这个魔法与剑的世界，他利用现代医药知识成为传奇般的药神。拯救苍生，同时也寻找回到原本世界的方法。',
    tags: ['穿越', '异世界', '医学', '冒险'],
    updatedAt: '2026-08-04',
    chapterList: [
      { num: 88, title: '第88话 - 瘟疫之源', date: '2026-08-04' },
      { num: 87, title: '第87话 - 新的配方', date: '2026-07-28' },
      { num: 86, title: '第86话 - 王国的请求', date: '2026-07-21' },
    ],
  },
  {
    id: 11,
    title: '假面',
    author: '崔智友',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20person%20wearing%20mask%20in%20mirror%20reflection%2C%20psychological%20suspense%20mood%2C%20cool%20dark%20tones%2C%20clean%20minimalist%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-11&orientation=portrait',
    category: 'thriller',
    rating: 9.1,
    views: 1270000,
    chapters: 42,
    status: '连载中',
    description: '一名整形外科医生发现他的病人接连离奇死亡。当他深入调查时，发现了一个令人毛骨悚然的真相。每个人都在戴着假面生活，包括他自己。',
    tags: ['悬疑', '医疗', '心理学', '惊悚'],
    updatedAt: '2026-07-31',
    chapterList: [
      { num: 42, title: '第42话 - 手术室的秘密', date: '2026-07-31' },
      { num: 41, title: '第41话 - 失踪的患者', date: '2026-07-24' },
      { num: 40, title: '第40话 - 双重人格', date: '2026-07-17' },
    ],
  },
  {
    id: 12,
    title: '逆袭人生',
    author: '林秀晶',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20confident%20businesswoman%20in%20modern%20office%2C%20empowering%20atmosphere%2C%20warm%20golden%20lighting%2C%20clean%20professional%20composition%2C%20digital%20illustration&width=400&height=560&seq=comic-12&orientation=portrait',
    category: 'drama',
    rating: 9.0,
    views: 1430000,
    chapters: 56,
    status: '连载中',
    description: '被公司裁员的单亲妈妈决定自己创业。从零开始，她面对各种挑战和困难，但凭借坚韧和智慧一步步实现人生逆袭。激励人心的女性成长故事。',
    tags: ['职场', '女性', '励志', '亲情'],
    updatedAt: '2026-08-02',
    chapterList: [
      { num: 56, title: '第56话 - 首轮融资', date: '2026-08-02' },
      { num: 55, title: '第55话 - 创业大赛', date: '2026-07-26' },
      { num: 54, title: '第54话 - 第一个客户', date: '2026-07-19' },
    ],
  },
  {
    id: 13,
    title: '花路',
    author: '安孝燮',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20cover%20art%2C%20two%20male%20idols%20on%20stage%20with%20spotlight%2C%20glamorous%20atmosphere%2C%20warm%20stage%20lighting%2C%20clean%20elegant%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-13&orientation=portrait',
    category: 'bl',
    rating: 9.4,
    views: 3600000,
    chapters: 90,
    status: '连载中',
    description: '两个男团偶像在竞争与合作中暗生情愫。在聚光灯下的秘密恋情，既要面对外界的压力，也要克服内心的挣扎。娱乐圈背景下的深情故事。',
    tags: ['娱乐圈', 'BL', '偶像', '浪漫'],
    updatedAt: '2026-08-01',
    hot: true,
    chapterList: [
      { num: 90, title: '第90话 - 颁奖典礼', date: '2026-08-01' },
      { num: 89, title: '第89话 - 回归舞台', date: '2026-07-25' },
      { num: 88, title: '第88话 - 绯闻危机', date: '2026-07-18' },
    ],
  },
  {
    id: 14,
    title: '甜心陷阱',
    author: '金素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cooking%20cover%20art%2C%20cheerful%20girl%20baking%20in%20pastry%20shop%2C%20sweet%20warm%20colors%2C%20cozy%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-14&orientation=portrait',
    category: 'comedy',
    rating: 8.9,
    views: 1120000,
    chapters: 48,
    status: '已完结',
    description: '甜品店的可爱女孩暗恋隔壁咖啡店的帅气店长。每天用甜品传递心意，却总是闹出各种笑话。甜蜜搞笑的恋爱喜剧，让人看了就想吃甜点。',
    tags: ['甜宠', '搞笑', '美食', '恋爱'],
    updatedAt: '2026-06-30',
    status: '已完结',
    chapterList: [
      { num: 48, title: '第48话 - 甜蜜结局（完结）', date: '2026-06-30' },
      { num: 47, title: '第47话 - 最后的甜点', date: '2026-06-23' },
      { num: 46, title: '第46话 - 告白蛋糕', date: '2026-06-16' },
    ],
  },
  {
    id: 15,
    title: '夜行书生',
    author: '赵寅成',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20fantasy%20cover%20art%2C%20mysterious%20scholar%20in%20ancient%20Korean%20hanbok%20under%20moonlight%2C%20elegant%20dark%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-15&orientation=portrait',
    category: 'fantasy',
    rating: 9.6,
    views: 2980000,
    chapters: 100,
    status: '已完结',
    description: '朝鲜时代，一位白天是普通书生、夜晚化身神秘侠客的青年。他游走于光明与黑暗之间，守护着被压迫的百姓。精彩的古装奇幻漫画，融合了历史与想象。',
    tags: ['古装', '奇幻', '动作', '历史'],
    updatedAt: '2026-05-20',
    status: '已完结',
    chapterList: [
      { num: 100, title: '第100话 - 黎明将至（完结）', date: '2026-05-20' },
      { num: 99, title: '第99话 - 最后的战斗', date: '2026-05-13' },
      { num: 98, title: '第98话 - 真相大白', date: '2026-05-06' },
    ],
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const hotComics = comics.filter(c => c.hot);
export const latestUpdates = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());